import React from 'react';
import { ThemeProvider } from 'styled-components';
import Theme from '../../design-system/Theme';

interface Props {
  children: React.ReactNode;
}

function Provider({ children }: Props) {
  const theme = new Theme();
  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
}

export default Provider;
